//import json from '../../../navigation/navigation.json'
const json1 = localStorage.getItem('pages')
import phdConfig from "./../../../../physician-portal/physician-desktop/shared/config/PHD-config.json";

import $ from 'jquery';
import localeEn from "./../../../../physician-portal/physician-desktop/locales/en";
import localeAr from "./../../../../physician-portal/physician-desktop/locales/ar";


export default {
	name: "nav-bar",
	component: {
		props: [
			'mega',
			'isActivelink',
			'products',
			'navEl'
		],
		template: ''
	},
	data: () => ({
		lang: localStorage.getItem('NG_TRANSLATE_LANG_KEY'),
		direction: '',
		mega: false,
		navEl: false,
		isActivelink: false,
		modules: json1,
		maxIndex: 0,
		minIndex: 0,
		visibleItemsSet: false,
		portal: "",
		hasPortal: false,
		tabCloseFlag: false,
	}),
	methods: {
		closeMenuIfOpened(evt) {
			this.collapseothers(evt);
			this.closeNavbar();
		},
		collapseothers(isExpand) {//collapse other mega menu when one is clicked
			let activeList = document.querySelectorAll('li.active-link');
			let direction = localStorage.getItem('NG_TRANSLATE_LANG_KEY') == 'en' ? 'left' : 'right';
			let RevDirection = localStorage.getItem('NG_TRANSLATE_LANG_KEY') == 'en' ? 'right' : 'left';
			for (var i = 0; i < activeList.length; i++) {
				if (!activeList[i].contains(event.target)) activeList[i].click()
			}
			let that =this
			setTimeout(
				function () {
					let megaMenu = $('.displayMega');
					if (megaMenu[0]) {
						if (megaMenu.offset().left + megaMenu.width() > $('body').width() || megaMenu.offset().left < 0) {
							if(that.lang == 'en'){
								megaMenu[0].style[direction] = 'auto';
								megaMenu[0].style[RevDirection] = '0px';
								if (megaMenu.offset().left < 0) {//if menu can`t open on left or right ,it need to be centered
									megaMenu[0].style[direction] = `-200px`;
									let count = 200;
									while (megaMenu.offset().left + megaMenu.width() > $('body').width()) {
										count += 200;
										megaMenu[0].style[direction] = `-${count}px`;
									}
								}
							}
							else{
								if (megaMenu.offset().left < 0) {//if menu can`t open on left or right ,it need to be centered
									let pushDir = megaMenu.offset().left-20
									megaMenu[0].style[direction] = pushDir+'px'
									megaMenu[0].style[RevDirection] = '0px';
									let count = 200;
									while (megaMenu.offset().left + megaMenu.width() > $('body').width()) {
										count += 200;
										megaMenu[0].style[direction] = `-${count}px`;
									}
								}
								else{
									megaMenu[0].style[direction] = 'auto';
									megaMenu[0].style[RevDirection] = '0px';
								}
							}
							setTimeout(function () { megaMenu[0].style.opacity = 1; }, 100);
						} 
						else {
							setTimeout(function () { megaMenu[0].style.opacity = 1; }, 100);
						}
					}
				}, 100
			)
			if (isExpand === true) {
				let megaMenu = $('.displayMega');
				megaMenu[0].style[RevDirection] = 'auto';
				megaMenu[0].style[direction] = '0px';
				megaMenu[0].style.opacity = 0;
			}

		},
		imagePath(mName) {
			mName = mName.replace(' ', '-');
			return '/nav/' + mName + '.svg'
		},
		filterMenuBackOfficePages() {
			let BOItems = JSON.parse(localStorage.getItem('pages'));
			var IsSaudiEntity = JSON.parse(localStorage.getItem('IsSaudiEntity'));
			if (IsSaudiEntity != null && IsSaudiEntity == false) {
				this.excludePageFromMainMenu(BOItems, "BO-3-BO-Supply Chain", "BO-3-Inventory Management", 'BO-3-Inventory Operations', 'RSDNotifications');
			}
			//BOItems = BOItems.filter(item => String(item.PageKey).startsWith('BO-'));
			BOItems.forEach(element => {
				element.isActivelink = false;
				element.isExpand = false;
			});
			this.modules = BOItems;
			this.modules.sort(this.sortAlphaNum);
		},
		sortAlphaNum: function (a, b) {
			var reA = /[^a-zA-Z]/g;
			var reN = /[^0-9]/g;

			var aA = a.ModuleName != null ? a.ModuleName.replace(reA, "") : '';
			var bA = b.ModuleName != null ? b.ModuleName.replace(reA, "") : '';
			if (aA === bA) {
				var aN = a.ModuleName ? parseInt(a.ModuleName.replace(reN, ""), 10) : 0;
				var bN = b.ModuleName ? parseInt(b.ModuleName.replace(reN, ""), 10) : 0;
				return aN === bN ? 0 : aN > bN ? 1 : -1;
			} else {
				return aA > bA ? 1 : -1;
			}
		},
		VisibleItemShow() {
			// menu show items
			this.lang == 'en' ? this.direction = 'left' : this.direction = 'right';
			setTimeout(() => {
				let list = $('li.list-inline-item.text-center');
				let ulWidth = $('.main-header .mega-menu ul#site-navigation').width()
				let itemWidth = $('li.list-inline-item.text-center:first-child').width();
				let visibleItems = ulWidth / itemWidth;
				let setMinIndex = true
				if (!this.visibleItemsSet) {
					list.each(function (index, li) {
						if (index <= (visibleItems - 1)) {
							$(li).css('visibility', 'visible')
						} else {
							$(li).css('visibility', 'hidden')
						}
					})
				}
				this.visibleItemsSet = true;

				if (ulWidth < (list.length * itemWidth)) {
					$('.main-header .mega-menu').addClass('btn-show');

					list.each((index, li) => {
						if (li.style.visibility == 'visible') {
							if (setMinIndex) {
								this.minIndex = index;
								setMinIndex = false;
							}
							this.maxIndex = index + 1
						}
					})
				}

				if (this.minIndex === 0) {
					$('#startDirBtn')[0].setAttribute('disabled', 'disabled')
				}



			}, 10)
		},
		startDirBtn: function () {

			if (this.tabCloseFlag === true) {
				this.collapseothers(false);
			}
			let list = $('li.list-inline-item.text-center');
			let item = $('li.list-inline-item.text-center:first-child');
			let DirectionVal = item.css(this.direction);
			let itemWidth = item.width();

			DirectionVal = parseInt(DirectionVal.replace('px', ''));
			if (DirectionVal != 0) {
				DirectionVal = DirectionVal + itemWidth;
				this.maxIndex = this.maxIndex - 1;
				this.minIndex = this.minIndex - 1;
				$(list.get(this.maxIndex)).css('visibility', 'hidden')
				$(list.get(this.minIndex)).css('visibility', 'visible')
				if ($(list.get(this.maxIndex)).find('.mega-menu-holder').hasClass('displayMega')) {

					$(list.get(this.maxIndex)).click();
				}

				list.each((index, li) => {
					$(li).css(this.direction, `${DirectionVal}px`)
				})
			}

			let megaMenu = $('.displayMega');

			if (megaMenu[0]) {
				if (megaMenu.offset().left + megaMenu.width() > $('body').width() || megaMenu.offset().left < 0) {
					$('li.list-inline-item.text-center.active-link').click();
					$('li.list-inline-item.text-center.active-link').click();
				}
			}

			if (this.minIndex === 0) {
				$('#startDirBtn')[0].setAttribute('disabled', 'disabled')
			}
			$('#endDirBtn')[0].removeAttribute('disabled')

		},
		endDirBtn: function () {
			if (this.tabCloseFlag === true) {
				this.collapseothers(false);
			}
			let list = $('li.list-inline-item.text-center');
			let item = $('li.list-inline-item.text-center:first-child');
			let DirectionVal = item.css(this.direction);
			DirectionVal = parseInt(DirectionVal.replace('px', ''));
			let listLength = list.length;
			let ulWidth = $('.main-header .mega-menu ul#site-navigation').width();
			let itemWidth = item.width();
			let scrollLimit = (listLength * -itemWidth) + ulWidth;

			if (Math.abs(DirectionVal) < Math.abs(scrollLimit)) {
				DirectionVal = DirectionVal - itemWidth;
				$(list.get(this.maxIndex)).css('visibility', 'visible')
				$(list.get(this.minIndex)).css('visibility', 'hidden')
				if ($(list.get(this.minIndex)).find('.mega-menu-holder').hasClass('displayMega')) {

					$(list.get(this.minIndex)).click();

				}
				list.each((index, li) => {
					$(li).css(this.direction, `${DirectionVal}px`)
				})

				this.maxIndex = this.maxIndex + 1;
				this.minIndex = this.minIndex + 1;
			}
			if (this.maxIndex === list.length) {
				$('#endDirBtn')[0].setAttribute('disabled', 'disabled')
			}
			$('#startDirBtn')[0].removeAttribute('disabled')

		},
		closeNavbar() {
			this.navEl = false;
		},
		init: function () {
			this.portal = { PageURL: phdConfig.physicianPortalURL, PageName: this.$i18n.t('PhysicianPortal.PhysicianPortal') };
			if (JSON.parse(localStorage.getItem('UnModuledPages')) && JSON.parse(localStorage.getItem('UnModuledPages')).length > 0) {
				this.hasPortal = true;
			}
		},
		excludePageFromMainMenu: function (itemList, moduleKey, subModulesListFilterKey, subModuleKey, pageKey) {
			let module = itemList.find(item => item.PageKey == moduleKey);
			if (module !== undefined) {
				let subModuleList = module.SubModulesList.find(p => p.PageKey == subModulesListFilterKey);
				if (subModuleList !== undefined) {
					let subModule = subModuleList.SubModule.find(n => n.PageKey == subModuleKey);
					if (subModule !== undefined) {
						subModule.PagesList = subModule.PagesList.filter(p => p.PageKey != pageKey);
					}
				}
			}
		}
	},
	computed: {

	},
	created() {
		this.init();
		this.filterMenuBackOfficePages()
	},
	mounted() {
		document.querySelectorAll('.fifthLink').forEach(item => {
			item.addEventListener("click", function () {
				item.nextElementSibling.classList.toggle("d-none");
				// this.mega=;
				this.mega = true;
				this.navEl = true;
			});
		});

		// this.filterMenuBackOfficePages()
		// Close mega menu if we open lang. or profile DDl
		let btns = document.querySelectorAll('.btn.dropdown-toggle.btn-link');
		btns.forEach(elem => {
			elem.addEventListener('click', () => {
				this.mega = false;
				this.navEl = false;
			});
		});

		this.$root.$on('CloseNavBar', () => {
			this.mega = false;
			this.navEl = false;
		});


	},
	i18n: {
		messages: {
			en: {
				...localeEn,
			},
			ar: {
				...localeAr,
			},
		},
	},
};
